import {Stack} from "@mui/material";
import {View} from "react-big-calendar";
import {CalendarToolbarProp} from "../Calendar";
import {ViewSwitcher} from "./ViewSwitcher";
import {Today} from "./Today";
import {CalendarFilter} from "./calendar-filter";
import {Navigator} from "./Navigator";

const CalendarToolbar: React.FC<
  CalendarToolbarProp & {
    disabled?: boolean;
  }
> = props => {
  const {date, view, disabled, onNavigate, onView} = props;

  const changeView = (view: View) => {
    onView(view);
  };

  return (
    <Stack
      onClick={e => e.stopPropagation()}
      direction="row"
      alignItems="center"
      className="calendar-toolbar"
      gap={1}
      pb={1}>
      <CalendarFilter />
      <Today onClick={() => onNavigate("TODAY")} disabled={disabled} />

      <Navigator
        onNavigate={onNavigate}
        date={date}
        view={view}
        disabled={disabled}
      />

      <ViewSwitcher view={view} onChange={changeView} disabled={disabled} />
    </Stack>
  );
};

export {CalendarToolbar};
